import React from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Sheet from "@mui/joy/Sheet";
import Textarea from "@mui/joy/Textarea";
import CircularProgress from "@mui/joy/CircularProgress";
import {unusedVendorProxiesApi} from "./proxiesApi";
import {NotificationService} from "../../common/notification";

type Props = {
    open: boolean
    setOpen: (open: boolean) => void
}

function formatLines(items: {id: string, ip: string}[]): string {
    return items.map(item => `${item.id};${item.ip}`).join("\n");
}

const UnusedVendorDialog = (props: Props) => {
    const {open, setOpen} = props;
    const [text, setText] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            return;
        }

        let cancelled = false;
        const load = async () => {
            setLoading(true);
            try {
                const result = await unusedVendorProxiesApi();
                if (cancelled) {
                    return;
                }
                if (!result.result || !result.value) {
                    NotificationService.alertError("Не удалось загрузить свободные слоты вендора");
                    setText("");
                    setCount(0);
                    return;
                }
                setCount(result.value.length);
                setText(formatLines(result.value));
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        load().catch(console.error);
        return () => {
            cancelled = true;
        };
    }, [open]);

    const copyAll = async () => {
        if (!text) {
            return;
        }
        try {
            await navigator.clipboard.writeText(text);
            NotificationService.alertSuccess("Скопировано");
        } catch {
            NotificationService.alertError("Не удалось скопировать");
        }
    };

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog sx={{minWidth: {sm: 480}, maxWidth: 640}}>
                <ModalClose/>
                <Typography level="h2">Свободные у вендора</Typography>
                <Typography level="body-sm">
                    Слоты Proxy-seller, которых нет в этой БД (id;ip). После сверки прода можно скопировать список в dev.
                </Typography>
                <Divider sx={{my: 1}}/>
                {loading ?
                    <CircularProgress/> :
                    <Sheet sx={{display: "flex", flexDirection: "column", gap: 1}}>
                        <Typography level="body-xs">
                            {count === 0 ? "Свободных слотов нет" : `Слотов: ${count}`}
                        </Typography>
                        <Textarea
                            minRows={8}
                            maxRows={16}
                            value={text}
                            readOnly
                            sx={{fontFamily: "monospace"}}
                        />
                        <Button
                            variant="solid"
                            disabled={!text}
                            onClick={() => copyAll().catch(console.error)}
                        >
                            Скопировать
                        </Button>
                    </Sheet>
                }
            </ModalDialog>
        </Modal>
    );
};

export default UnusedVendorDialog;
